// extracted by mini-css-extract-plugin
export var subtitle = "_redotech-redo-web-src-tooltip-tooltip-subtitle";